// @flow
// Types
import type {
  Job,
} from 'fc-model-sampling-jobs/types'

// Constants
import {
  PROP_CREATED_BY,
  PROP_SUBFIELD,
} from 'fc-model-sampling-jobs'

// Export
export default function validateModel (model: Job): Array<{[string]: string}> {
  const errors = []
  try {
    if (!model[PROP_CREATED_BY]) {
      errors.push(
        { [PROP_CREATED_BY]: `${PROP_CREATED_BY} isRequired` }
      )
    }

    if (!model[PROP_SUBFIELD]) {
      errors.push(
        { [PROP_SUBFIELD]: `${PROP_SUBFIELD} isRequired` }
      )
    }
  } catch (error) {
    errors.push({error: error})
  }

  return errors
}
